<a #languageCollapse class="dropdown-item" role="button" data-bs-toggle="collapse" data-bs-target="#lang"
  aria-expanded="false">
  <span class="fw-normal me-2">{{ 'language' | translate }}</span>
</a>
<div id="lang" class="collapse">
  <div class="lang-body">
    @for (lang of languages; track $index) {
    <span data-bs-toggle="collapse" data-bs-target="#lang">
      <a class="dropdown-item ps-4" (click)="changeLanguage(lang.code)">
        <span>{{lang.name}}</span>
      </a>
    </span>
    }
  </div>
</div>
